import { notification } from "antd";

export const copyObjectToClipboard = async (
    data: object | string,
): Promise<void> => {
    try {
        const text =
            typeof data === "string"
                ? data
                : `\`\`\`json\n${JSON.stringify(data, null, 2)}\n\`\`\``;

        await navigator.clipboard.writeText(text);
        notification.success({
            message: "Успішно скопійовано!",
        });
    } catch (error) {
        console.error("Помилка при копіюванні:", error);
        notification.error({
            message: "Не вдалось скопіювати інформацію",
            description: String(error),
        });
    }
};
